import * as Tabs from '@radix-ui/react-tabs';
import { HowToUseItemProps, ProductDescriptionItemProps } from "./constants";
import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import ReactPlayer from 'react-player/youtube';


interface TabDetailProps {
  details: Array<ProductDescriptionItemProps>;
  how_to_use: Array<HowToUseItemProps>;
}

const TabDetail = (props: TabDetailProps) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [videoHeight, setVideoHeight] = useState(0);
  const videoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoRef.current !== null) {
      setVideoHeight(videoRef.current.offsetWidth * 0.5625);
    }
  }, [activeTab])

  const generate_how_to_use = () => {
    return props.how_to_use.map((use, index) => {
      if (use.title !== "" && use.description !== "") {
        return (
          <div key={index} className="mt-4">
            <p className="font-bold">{use.title}</p>
            <p className="font-normal">{use.description}</p>
          </div>
        );
      } else if (use.title !== "" && use.document !== "") {
        return (
          <div key={index} className="mt-4">
            <Link href={use.document} className="underline text-mooimom">
              {use.title}
            </Link>
          </div>
        );
      } else if (use.video_link !== "") {
        return (
          <div key={index} className="w-full mt-4" ref={videoRef}>
            <ReactPlayer
              url={use.video_link}
              width="100%"
              height={videoHeight}
              playing={false}
              loop={true}
              controls={true}
              muted={true}
            />
          </div>
        );
      } else {
        return (<></>);
      }
    });
  }

  return (
    <Tabs.Root
      className="w-full"
      defaultValue="tab1"
      onValueChange={(value) => setActiveTab(value)}
    >
      <Tabs.List className="flex justify-between border-b border-solid border-reviewBg">
        {props.details.map((detail, index) => (
          <Tabs.Trigger key={index} value={`tab${index + 1}`} className={`text-sm font-poppins hover:text-mooimom font-bold leading-8 pb-2 ${activeTab === `tab${index + 1}` ? "text-mooimom border-b-4 border-mooimom border-solid" : "text-black"}`}>
            {detail.title.length > 0 ? detail.title : "Deskripsi"}
          </Tabs.Trigger>
        ))}
        {props.how_to_use.length > 0 && (
          <Tabs.Trigger key={props.details.length + 1} value={`tab${props.details.length + 2}`} className={`text-sm font-poppins hover:text-mooimom font-bold leading-8 pb-2 ${activeTab === `tab${props.details.length + 2}` ? "text-mooimom border-b-4 border-mooimom border-solid" : "text-black"}`}>
            Instruksi Manual
          </Tabs.Trigger>
        )}
      </Tabs.List>
      {props.details.map((detail, index) => (
        <Tabs.Content key={index} value={`tab${index + 1}`} className="mt-3">
          <p className="text-sm leading-8 text-black font-poppins" dangerouslySetInnerHTML={{__html: detail.description.replace(/(?:\r\n|\r|\n)/g, '<br />')}}></p>
        </Tabs.Content>
      ))}
      {props.how_to_use.length > 0 && (
        <Tabs.Content value={`tab${props.details.length + 2}`} className="mt-3">
          {generate_how_to_use()}
        </Tabs.Content>
      )}
    </Tabs.Root>
  ) 
}

export default TabDetail;
